import { loading } from './reducers/loading';
import { loadEvents } from './reducers/loadEvents';
import { newOrder } from './reducers/newOrder';
import { confirmRejectPoint } from './reducers/confirmRejectPoint';
import { cancelOrder } from './reducers/cancelOrder';
import { newCall } from './reducers/newCall';
import { cancelCall } from './reducers/cancelCall';
import { completeCall } from './reducers/completeCall';
import { reset } from './reducers/reset';
import { handleAssignees } from './reducers/handleAssignees';

const EventsReducer = (state, action) => {
  switch (action.type) {
    case 'ORDER_NEW':
      return newOrder(state, action.payload);
    case 'ORDER_CANCEL':
      return cancelOrder(state, action.payload);
    case 'COMPLETE_POINT':
      return confirmRejectPoint(state, action.payload);

    case 'CALL_NEW':
      return newCall(state, action.payload);
    case 'CALL_CANCEL':
      return cancelCall(state, action.payload);
    case 'CALL_COMPTETED':
      return completeCall(state, action.payload);

    case 'EVENTS_ASSIGN':
      return handleAssignees(state, action.payload);

    case 'LOAD_EVENTS':
        return loadEvents(state, action.payload);

    case 'LOADING':
      return loading(state, action.payload);

    case 'RESET':
      return reset(state, action.payload);

    default:
      console.log('NO MESSAGE TYPE FOUND FOR', action.type)
      return state;
  }
};

export default EventsReducer;
